// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_round_status */
var FoodSensoryRoundStatus;
(function (FoodSensoryRoundStatus) {
    FoodSensoryRoundStatus["pending"] = "pending";
    FoodSensoryRoundStatus["open"] = "open";
    FoodSensoryRoundStatus["revealed"] = "revealed";
})(FoodSensoryRoundStatus || (FoodSensoryRoundStatus = {}));
;
export default FoodSensoryRoundStatus;
/** Zod schema for food_sensory_round_status */
export const foodSensoryRoundStatus = z.nativeEnum(FoodSensoryRoundStatus);
//# sourceMappingURL=FoodSensoryRoundStatus.js.map